import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'

import BkFlowStructuredSidebarSkipStepButton from './elements/BkFlowStructuredSidebarSkipStepButton'
import BkFlowStructuredSidebarPropertySummary from './elements/BkFlowStructuredSidebarPropertySummary'
import BkFlowStructuredSidebarStayDates from './elements/BkFlowStructuredSidebarStayDates'
import BkFlowStructuredSidebarRoomCard from './elements/BkFlowStructuredSidebarRoomCard'
import BkFlowStructuredSidebarStayTotals from './elements/BkFlowStructuredSidebarStayTotals'
import BkFlowStructuredSidebarAmenities from './BkFlowStructuredSidebarAmenities'
import BkFlowStructuredSidebarMobileGrandTotal from './mobile/BkFlowStructuredSidebarMobileGrandTotal'

import triggerCustomGaEvent from '../../../utilities/analytics/triggerCustomGaEvent'
import removeActiveEnhancement from '../../../actions/removeActiveEnhancementActions'
import setActiveStep from '../../../actions/activeStepActions'

import _ from 'lodash'
import yn from 'yn'
import moment from 'moment'
import Collapse from "@material-ui/core/Collapse";

if (yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR)) {
	require('../../../styles/css/components/structure/sidebar/bk-flow-structured-sidebar.css')
}

class BkFlowStructuredSidebar extends Component {
	constructor(props) {
		super(props)
		this.state = {
			mobileAccordionExpanded: false
		}
	}

	toggleMobileAccordion = () => {
		this.setState({
			mobileAccordionExpanded: !this.state.mobileAccordionExpanded
		})
	}

	render() {
		const {
			activeCurrencyData,
			activeEnhancementData,
			activeRoomData,
			activeStep,
			availabilityData,
			configData,
			handleContinuePayment,
			handleRemoveEnhancement,
			toggleEditModal,
			urlData,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		let activeHotelCode = null
		let matchedProperty = null
		let displayedPriceFrequency = 'per stay'
		let propertyNumbers = null
		let propertyAddress = null
		let totalNights = null
		let isTaxInclusiveProperty = false

		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (
			!_.isEmpty(urlData) &&
			urlData.startDate &&
			urlData.endDate
		) {
			totalNights = moment(urlData.endDate).diff(moment(urlData.startDate), 'days')
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			matchedProperty = configProperties.find(function (property) {
				return property.hotelCode === String(activeHotelCode)
			})
		}

		if (matchedProperty) {
			if (matchedProperty.address) {
				propertyAddress = matchedProperty.address
			}
			if (matchedProperty.contactNumbers) {
				propertyNumbers = matchedProperty.contactNumbers
			}

			if (matchedProperty.displayPricesTimeline) {
				displayedPriceFrequency = matchedProperty.displayPricesTimeline
			}
		}

		if (
			!_.isEmpty(matchedProperty) &&
			matchedProperty.displayPricesTaxInclusive
		) {
			isTaxInclusiveProperty = matchedProperty.displayPricesTaxInclusive
		}

		let activeHotel = null

		if (
			!_.isEmpty(availabilityData.availability) &&
			_.get(availabilityData.availability, '[0][0].basicPropertyInfo')
		) {
			if (_.get(availabilityData.availability, '[0][0].basicPropertyInfo.hotelName')) {
				activeHotel = availabilityData.availability[0][0].basicPropertyInfo.hotelName
			}
		}

		let flowGuestData = null,
				activeGuestData = []

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		if (flowGuestData) {
			for (const guestKey in flowGuestData) {
				activeGuestData.push(
					flowGuestData[guestKey]
				)
			}
		} else if (
			urlData &&
			urlData.adults
		) {
			let currentAdults = urlData.adults,
					currentChildren = 0

			if (urlData.children) {
				currentChildren = urlData.children
			}

			activeGuestData.push(
				{
					adults: currentAdults,
					children: currentChildren,
					dogs: false,
					cats: false
				}
			)
		}

		let propertyAmenities = []

		if (
			!_.isEmpty(availabilityData.availability) &&
			_.get(availabilityData.availability, '[0][0].viewExtensions.amenities')
		) {
			propertyAmenities = availabilityData.availability[0][0].viewExtensions.amenities
		}

		return (
			<Fragment>
				<div className="bk-flow-structured-sidebar">
					{yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR_SKIP_STEP_BUTTON) &&
						<BkFlowStructuredSidebarSkipStepButton
							activeEnhancementData={activeEnhancementData}
							activeStep={activeStep}
							handleContinuePayment={handleContinuePayment}
							hotelLabels={hotelLabels}
						/>
					}
					<div className="bk-flow-structured-sidebar__summary">
						<div className="bk-flow-structured-sidebar__heading">
							<h6 className="u-remove-margin">
								{
									hotelLabels &&
									hotelLabels.bookingSummary ?
										hotelLabels.bookingSummary
									:
										'Booking Summary'
								}
							</h6>
						</div>

						<div className="bk-flow-structured-sidebar__content">
							<BkFlowStructuredSidebarPropertySummary
								activeHotel={activeHotel}
								hotelLabels={hotelLabels}
								propertyAddress={propertyAddress}
								propertyNumbers={propertyNumbers}
								toggleEditModal={toggleEditModal}
							/>

							{ urlData && (urlData.startDate || urlData.endDate) &&
								<BkFlowStructuredSidebarStayDates
									hotelLabels={hotelLabels}
									urlData={urlData}
									toggleEditModal={toggleEditModal}
								/>
							}
						</div>

						{ activeGuestData &&
							!_.isEmpty(activeGuestData) &&
							Object.keys(activeGuestData).map(roomKey => {
								return (
									<BkFlowStructuredSidebarRoomCard
										key={'structured-sidebar-' + roomKey}
										activeCurrencyData={activeCurrencyData}
										activeEnhancementData={activeEnhancementData}
										activeGuestData={activeGuestData[roomKey]}
										activeRoomData={activeRoomData}
										displayedPriceFrequency={displayedPriceFrequency}
										handleRemoveEnhancement={handleRemoveEnhancement}
										hotelLabels={hotelLabels}
										isTaxInclusiveProperty={isTaxInclusiveProperty}
										roomKey={roomKey}
										totalNights={totalNights}
									/>
								)
							})
						}

						{ activeRoomData && !_.isEmpty(activeRoomData) &&
							<BkFlowStructuredSidebarStayTotals
								activeCurrencyData={activeCurrencyData}
								activeEnhancementData={activeEnhancementData}
								activeRoomData={activeRoomData}
								hotelLabels={hotelLabels}
								isTaxInclusiveProperty={isTaxInclusiveProperty}
								totalNights={totalNights}
							/>
						}
					</div>


					{ yn(process.env.REACT_APP_COMPONENT_PROPERTY_AMENITIES_SIDEBAR) &&
						!_.isEmpty(propertyAmenities) &&
							<BkFlowStructuredSidebarAmenities
								configData={configData}
								propertyAmenities={propertyAmenities}
							/>
					}
				</div>

				{!_.isEmpty(activeRoomData) &&
					<div className="bk-flow-structured-sidebar__mobile-accordion">
						<button
							className="bk-flow-structured-sidebar__heading"
							onClick={() => this.toggleMobileAccordion()}
							tabIndex={0}
						>
							<span className="heading-label">
								{ hotelLabels &&
									hotelLabels.bookingSummary ?
									hotelLabels.bookingSummary
								:
									'Booking Summary'
								}
							</span>

							<span className="heading-toggle">
								{hotelLabels && hotelLabels.view ?
									hotelLabels.view
								:
									'View'
								}

								{this.state.mobileAccordionExpanded ?
									<i className="material-icons mobile">remove</i>
								:
									<i className="material-icons mobile">add</i>
								}
							</span>
						</button>

						<Collapse
							className="bk-flow-structured-sidebar__summary"
							in={this.state.mobileAccordionExpanded}
							timeout={500}
						>
							{ activeGuestData &&
								!_.isEmpty(activeGuestData) &&
								Object.keys(activeGuestData).map(roomKey => {
									return (
										<BkFlowStructuredSidebarRoomCard
											key={'structured-sidebar-' + roomKey}
											activeCurrencyData={activeCurrencyData}
											activeEnhancementData={activeEnhancementData}
											activeGuestData={activeGuestData[roomKey]}
											activeRoomData={activeRoomData}
											handleRemoveEnhancement={handleRemoveEnhancement}
											hotelLabels={hotelLabels}
											isTaxInclusiveProperty={isTaxInclusiveProperty}
											roomKey={roomKey}
											totalNights={totalNights}
										/>
									)
								})
							}

							{ activeRoomData && !_.isEmpty(activeRoomData) &&
								<BkFlowStructuredSidebarStayTotals
									activeCurrencyData={activeCurrencyData}
									activeEnhancementData={activeEnhancementData}
									activeRoomData={activeRoomData}
									hotelLabels={hotelLabels}
									isTaxInclusiveProperty={isTaxInclusiveProperty}
									totalNights={totalNights}
									isMobile={true}
								/>
							}
						</Collapse>

						<BkFlowStructuredSidebarMobileGrandTotal
							activeCurrencyData={activeCurrencyData}
							activeEnhancementData={activeEnhancementData}
							activeRoomData={activeRoomData}
							hotelLabels={hotelLabels}
							isTaxInclusiveProperty={isTaxInclusiveProperty}
						/>
					</div>
				}
			</Fragment>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		activeEnhancementData: state.activeEnhancementData,
		activeRoomData: state.activeRoomData,
		activeStep: state.activeStepData.activeStep,
		activeCurrencyData: state.activeCurrencyData,
		availabilityData: state.availabilityData,
		urlData: state.availabilityData.urlData,
	}
}

const mapDispatchToProps = dispatch => ({
	handleRemoveEnhancement(activeEnhancements, enhancementKey) {
		triggerCustomGaEvent('analytics-removeService', enhancementKey)

		return dispatch(removeActiveEnhancement(enhancementKey))
	},
	handleContinuePayment(activeStep) {
		return dispatch(setActiveStep(activeStep + 1))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowStructuredSidebar)


// WEBPACK FOOTER //
// ./src/components/structure/sidebar/BkFlowStructuredSidebar.js